import { render, staticRenderFns } from "./TowerPanel.vue?vue&type=template&id=80cea04a&scoped=true"
import script from "./TowerPanel.vue?vue&type=script&lang=js"
export * from "./TowerPanel.vue?vue&type=script&lang=js"
import style0 from "./TowerPanel.vue?vue&type=style&index=0&id=80cea04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cea04a",
  null
  
)

export default component.exports